export enum ESumsubKeys {
  GET_APPLICATION_STATUS = 'Get applicant status',
  CREATE_APPLICANT = 'create applicant',
  SUMSUB_ACCESS_TOKEN = 'sumsub access token'
}

export enum ESumsubApplicantStatus {
  INIT = 'init',
  PENDING = 'pending',
  PRECHECKED = 'prechecked',
  QUEUED = 'queued',
  COMPLETED = 'completed',
  ONHOLD = 'onHold'
}
